import { moneyAutomationFeatureConfig as base } from './base';
import { moneyAutomationFeatureConfigCZ as CZ } from './CZ';
import { moneyAutomationFeatureConfigSK as SK } from './SK';
import { moneyAutomationFeatureConfigHU as HU } from './HU';

export const moneyAutomationFeatureConfigMap = {
    base,
    CZ,
    SK,
    HU,
};
